import { get } from 'lodash';
import { activityTypes } from 'constants/seasons';
import { scriptTypes } from 'constants/scripts';
import { formatDateToCalendarYear } from 'util/formatters/dateFormatter';

export const getSeasonActivityTypeForScriptType = (state, scriptType) => {
  switch (scriptType) {
    case scriptTypes.FERTILITY:
      return activityTypes.FERTILITY_APPLICATION;
    case scriptTypes.PLANTING:
      return activityTypes.PLANTING;
    case scriptTypes.APPLICATION:
      return activityTypes.APPLICATION;
    case scriptTypes.EXPERIMENT:
      return activityTypes.APPLICATION;
    default:
      return null;
  }
};

export const getSeasonByDateAndSeasonActivityTypeAndCropId = ({ state, date, seasonActivityType, cropId }) => {
  const year = formatDateToCalendarYear(date);
  return get(state, `${year}.${seasonActivityType}.${cropId}`);
};
